module.exports = __webpack_public_path__ + "img/add_student.ed4b565e.png";